import React, {FC} from 'react';
import {useForm} from 'react-hook-form';
import {StudentCreateRequest, StudentSourceNameMap} from '../../shared/types/student';
import {createStudentFetch} from '../../app/axios/studentFetches';
import HLFormInput from '../../shared/components/input/HLFormInput';
import HLButton, {HLButtonStyleType} from '../../shared/components/button/HLButton';
import HLErrorMessage from '../../shared/components/error-message/HLErrorMessage';
import HLModal from '../../shared/components/modal/HLModal';
import {processFormServerError} from '../../shared/utils/processFormServerError';
import HLFormSelect from "../../shared/components/select/HLFormSelect";

interface CreateStudentModalProps {
    open: boolean;
    setOpen: (value: boolean) => void;
    onSuccess: (id: number) => void;
}

const studentSourceOptions = Object.entries(StudentSourceNameMap).map(([value, label]) => ({
    value,
    label
}));

const CreateStudentModal: FC<CreateStudentModalProps> = (
    {
        open,
        setOpen,
        onSuccess
    }) => {
    const {
        register,
        handleSubmit,
        reset,
        setError,
        watch,
        formState: {errors, isSubmitting}
    } = useForm<StudentCreateRequest>();

    const createStudent = async (request: StudentCreateRequest) => {
        try {
            const student = await createStudentFetch(request)
            closeModal()
            onSuccess(student.id)
        } catch (err: any) {
            processFormServerError(err, setError)
        }
    };

    const closeModal = () => {
        reset()
        setOpen(false)
    };

    return (
        <HLModal open={open} onClose={closeModal} title="Создать ученика">
            <form onSubmit={handleSubmit(createStudent)} className="columnContainer">
                <HLErrorMessage error={errors.root?.message}/>

                <HLFormInput
                    id="firstName"
                    {...register('firstName', {required: 'Имя обязательно'})}
                    placeholder="Имя"
                    error={errors.firstName?.message}
                />

                <HLFormInput
                    id="lastName"
                    {...register('lastName')}
                    placeholder="Фамилия (необязательно)"
                    error={errors.lastName?.message}
                />

                <HLFormInput
                    id="telegram"
                    {...register('telegram')}
                    placeholder="Telegram (необязательно)"
                    error={errors.telegram?.message}
                />

                <HLFormInput
                    id="email"
                    {...register('email')}
                    placeholder="Email (необязательно)"
                    error={errors.email?.message}
                />

                <HLFormSelect
                    id="role"
                    {...register('source', {required: 'Источник обязателен'})}
                    value={watch('source') || ''}
                    options={[
                        {value: '', label: 'Откуда пришёл'},
                        ...studentSourceOptions
                    ]}
                    error={errors.source?.message}
                />

                <div className="inlineContainer">
                    <HLButton type="submit" disabled={isSubmitting}>
                        Создать
                    </HLButton>
                    <HLButton type="button" onClick={closeModal} styleType={HLButtonStyleType.GRAY}>
                        Отмена
                    </HLButton>
                </div>
            </form>
        </HLModal>
    );
};

export default CreateStudentModal; 